var separatorMatcher = (() => {
  // no suggestions
  return null;
});

export { separatorMatcher as default };
//# sourceMappingURL=feedback.esm.js.map
